// removed by extract-text-webpack-plugin
module.exports = {"freqQuestionsWrap":"qempo_FreqQuestions_freqQuestionsWrap-3B23Ptj","title":"qempo_FreqQuestions_title-zTpvVjN","caret":"qempo_FreqQuestions_caret-1-vJYkI","content":"qempo_FreqQuestions_content-3Y6_nFi","open":"qempo_FreqQuestions_open-1UmTu2q"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/FreqQuestions/FreqQuestions.scss
// module id = 1420
// module chunks = 0